module.exports = __webpack_public_path__ + "static/CVS-Catch-DLB-7-8-HUMANITIES-V5.2-7982af6a45bbd906af13c3ad32a365e7.pdf";